import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { closeOfferPreview } from '../../../../common/actions/closeOfferPreview/closeOfferPreview';
import { fetchHybridSearchData } from '../../../../common/actions/fetchHybridSearchData';
import { IFetchMapDataParameters } from '../../../../common/actions/fetchMapData/fetchMapData';
import { closeMobileListing } from '../../../../common/actions/listingModal';
import { TThunkDispatch } from '../../../../common/types/redux';

type TReloadHybridSearchAfterMapInteractionParameters = Omit<
  IFetchMapDataParameters,
  'deviceType' | 'requestJsonQuery'
>;

export function useReloadHybridSearchAfterMapInteraction(): (
  parameters?: TReloadHybridSearchAfterMapInteractionParameters,
) => void {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();

  return React.useCallback(
    (parameters: TReloadHybridSearchAfterMapInteractionParameters = {}) => {
      if (deviceType !== 'desktop') {
        dispatch(closeOfferPreview());
        dispatch(closeMobileListing());
      }

      dispatch(fetchHybridSearchData({ ...parameters, deviceType }));
    },
    [deviceType, dispatch],
  );
}
